// extracted by mini-css-extract-plugin
module.exports = {"container":"container--DemoSpacesTimeline-DemoSpaceTimeline-DemoSpace-routes__r7e0z"};